import { QueryDocumentSnapshot } from 'firebase/firestore';

export enum CollectionName {
  apiKeys = 'apiKeys',
  users = 'users',
  userRoles = 'userRoles',
  userGroups = 'userGroups',
  tenants = 'tenants',
  projects = 'projects',
  assets = 'assets',
  faces = 'faces',
  assetShares = 'assetShares',
  assetMatches = 'assetMatches',
  uploads = 'uploads',
  models = 'models',
  forms = 'forms',
  notifications = 'notifications',
  modelConsents = 'modelConsents',
  embeddings = 'embeddings',
  tags = 'tags',
  tagGroups = 'tagGroups',
  menus = 'menus',
  presets = 'presets',
  searchPins = 'searchPins',
  attachments = 'attachments',
  collections = 'collections',
  guides = 'guides',
  guideTypes = 'guideTypes',
  guideSections = 'guideSections',
  guideBlocks = 'guideBlocks',
  addonSessions = 'addonSessions',
  usage = 'usage',
}

export const typedConverter = <T>() => ({
  toFirestore: (data: T) => data,
  fromFirestore: (snap: QueryDocumentSnapshot) => snap.data() as T,
});
